import { StatusTone, VarianceLevel } from '../models/detail-page.model'

export function formatMinutes(mins: number | null | undefined): string {
    if (mins == null || isNaN(mins)) return '—'
    const total = Math.round(mins)
    const h = Math.floor(total / 60)
    const m = total % 60
    return `${h}h ${m.toString().padStart(2, '0')}m`
}

export function formatHours(hours: number | null | undefined): string {
    if (hours == null || isNaN(hours)) return '—'
    return formatMinutes(hours * 60)
}

export function variancePctFromRatio(ratio: number | null | undefined): number | null {
    if (ratio == null || isNaN(ratio)) return null
    return Math.round((ratio - 1) * 100)
}

export function efficiencyPctFromRatio(ratio: number | null | undefined): number | null {
    if (ratio == null || isNaN(ratio) || ratio <= 0) return null
    return Math.round((1 / ratio) * 100)
}

export function varianceLevelFromRatio(ratio: number | null | undefined): VarianceLevel {
    if (ratio == null || isNaN(ratio)) return 'unknown'
    if (ratio > 1.1) return 'over'
    if (ratio < 0.9) return 'under'
    return 'ok'
}

export function varianceClassFromRatio(ratio: number | null | undefined): string {
    return `variance-${varianceLevelFromRatio(ratio)}`
}

export function efficiencyLevelFromRatio(ratio: number | null | undefined): VarianceLevel {
    const eff = efficiencyPctFromRatio(ratio)
    if (eff == null) return 'unknown'
    if (eff < 70) return 'over'
    if (eff < 90) return 'under'
    return 'ok'
}

export function efficiencyClassFromRatio(ratio: number | null | undefined): string {
    return `variance-${efficiencyLevelFromRatio(ratio)}`
}

export function statusTone(status: string | undefined | null): StatusTone {
    switch ((status || '').toLowerCase()) {
        case 'running':
        case 'active':
        case 'in_progress':
            return 'primary'
        case 'completed':
        case 'success':
        case 'ok':
            return 'success'
        case 'aborted':
        case 'cancelled':
            return 'secondary'
        case 'warning':
        case 'pending':
            return 'warning'
        case 'error':
        case 'failed':
        case 'danger':
            return 'danger'
        case 'info':
            return 'info'
        default:
            return 'neutral'
    }
}
